"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useT } from "@/lib/i18n";
import CharacterTag from "@/app/components/CharacterTag";
const API = process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:8000";
interface Summary {
  total: number;
  by_character: Record<string, number>;
}
export default function ReplaySummary(t0) {
  const $ = _c(14);
  const {
    charName
  } = t0;
  const t = useT();
  const [summary, setSummary] = useState(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const controller = new AbortController();
      fetch(`${API}/api/replays/summary`, {
        signal: controller.signal
      }).then(_temp).then(data => {
        if (controller.signal.aborted) {
          return;
        }
        if (data && typeof data.total === "number") {
          setSummary(data);
        }
      }).catch(_temp2);
      return () => controller.abort();
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  if (!summary || summary.total === 0) {
    return null;
  }
  let t3;
  if ($[2] !== charName || $[3] !== summary.by_character || $[4] !== summary.total || $[5] !== t) {
    const entries = Object.entries(summary.by_character || {}).filter(_temp3).sort(_temp4);
    let t4;
    if ($[7] !== summary.total || $[8] !== t) {
      t4 = t("{n} watchable replays", {
        n: summary.total.toLocaleString()
      });
      $[7] = summary.total;
      $[8] = t;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    if ($[10] !== t4) {
      t5 = <span className="font-semibold text-[var(--text-primary)]">{t4}</span>;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== charName) {
      t6 = t7 => {
        const [id, n_0] = t7;
        return <span key={id} className="inline-flex items-center gap-1.5 text-[var(--text-muted)]"><CharacterTag id={id} showName={false} size={16} name={charName(id)} /><span className="text-[var(--text-primary)]">{charName(id)}</span><span>{n_0.toLocaleString()}</span></span>;
      };
      $[12] = charName;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    t3 = <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mb-4 rounded-lg border border-[var(--border-subtle)] bg-[var(--bg-card)] px-3 sm:px-4 py-2.5 text-xs">{t5}{entries.map(t6)}</div>;
    $[2] = charName;
    $[3] = summary.by_character;
    $[4] = summary.total;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp4(a, b) {
  return b[1] - a[1];
}
function _temp3(t0) {
  const [, n] = t0;
  return n > 0;
}
function _temp2() {}
function _temp(r) {
  return r.ok ? r.json() : null;
}